<template>
  <main>
    <wl-banner bgUrl='/static/img/product/yqyy/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc' class="mytitle"></wl-title>
      </article>
    </section>
    <section class="page2">
      <article class="container">
        <wl-title title='大型仪器管理痛点问题' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section v-for="(item,idx) in page2Data" :key="item.key" class="box">
            <section class="img"><img v-lazy="'/static/img/product/yqyy/'+item.key+'.png'" :alt="item.title"></section>
            <h3 :class="{'pt-30':idx===2||idx===3}">{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/yqyy/bg3.png'">
      <article class="container">
        <wl-title title='解决方案' desc='建设一套从人、机、物全方位管控的解决方案，赋予大精仪识别身份，在线预约，使用权限，计算机时，费用统计的能力'></wl-title>
      </article>
    </section>
    <section class="page4 bg" v-lazy:background-image="'/static/img/product/yqyy/bg4.png'">
      <article class="container">
        <wl-title title='产品特性' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="box" v-for="(item,idx) in page4Data" :key="item.key" @mouseenter="mouseEnter(idx)" @mouseleave="page4HoverId = null">
            <section class="_icon " :style="page4HoverId===idx?`background-position: -${72+144*idx}px 0px;`:`background-position: -${144*idx}px 0px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'yqyuyuegxManageSystem',
  data() {
    return {
      bannerData: {
        title: '仪器预约共享管理系统',
        desc: '仪器预约，开放共享\n提高使用效率，设备精细管理'
      },
      page1Data: {
        title: '仪器预约共享管理系统',
        desc: '仪器预约共享管理系统通过智能化管理手段，实现仪器的开放共享、预约授权、使用控制、计时计费、统计分析、数据上报等业务流程，为实验用户提供便捷高效的平台服务，有效减少仪器管理人员管理上的繁杂手续，提高工作效率，使资源得到合理利用。'
      },
      page2Data: [
        { title: '校级领导', desc: '仪器使用情况无法真实掌握\n仪器共享率不知\n数据上报格式复杂 人工统计效率低', key: 'p2-1' },
        { title: '课题组管理', desc: '仪器经费使用情况无法有效掌握\n审批流程复杂多样效率低', key: 'p2-2' },
        { title: '仪器管理员', desc: '仪器设备运行状态不能全程监控\n设备故障发现不及时\n仪器设备盘点、清理难\n计时计费人工统计难、数据不准', key: 'p2-3' },
        { title: '学生使用者', desc: '线下预约排队时间长，预约受限\n仪器规则制度不明确，查找仪器费时费力\n仪器收费不透明，无法查看费用明细', key: 'p2-4' },
      ],
      page4Data: [
        { key: 'yqyy-icon1', title: '校院两级，数据互通', desc: '校级、院级、集团、各部门分别管理仪器，数据灵活互通，实现跨学院、跨部门管理' },
        { key: 'yqyy-icon2', title: '仪器控制，预约授权', desc: '自主使用预约和送样预约\n多方式智能控制上机，无需管理员值守' },
        { key: 'yqyy-icon3', title: '财务管理，计时计费', desc: '多样化收费方式、收费标准\n自动生成缴费清单，结算清晰透明' },
        { key: 'yqyy-icon4', title: '信用管理，规范行为', desc: '可设定违约次数，实施信用积分管理，超限自动取消预约资格，有效规范用户行为' },
        { key: 'yqyy-icon5', title: '维修维护，预警提示', desc: '仪器设备维修维护流程化管理\n维修维护校准提醒' },
        { key: 'yqyy-icon6', title: '智能统计，数据上报', desc: '对接国家顶层平台、第三方系统，智能统计实时数据，轻松上报' },
        { key: 'yqyy-icon7', title: '硬件联动，GIS地图定位', desc: '智能硬件联动，实时数据采集\nGIS北斗定位追踪，实时监控仪器状态' },
        { key: 'yqyy-icon8', title: '数据大屏，可视化展示', desc: '多维度展示仪器数据\n直观展现仪器运行情况' },
      ],
      page4HoverId: null,
    }
  },
  methods: {
    mouseEnter(index) {
      this.page4HoverId = index
    },
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/yqyy/icon.png");
}
main {
  background: #fbfbff;
}
h3 {
  font-size: 22px;
  font-weight: 500;
  color: #262626;
  line-height: 22px;
  padding-bottom: 19px;
  padding-top: 42px;
  padding-bottom: 16px;
  padding-top: 16px;
}
p {
  font-size: 20px;
  color: #8e8e8e;
  line-height: 30px;
  white-space: pre-line;
}
.pt-30 {
  padding-top: 32px !important;
}
.page1 {
  height: 545px;
  padding-top: 164px;
  background: url("/static/img/product/yqyy/bg1.png") center/cover;
  text-align: left;
  .mytitle {
    width: 587px;
    margin-left: 670px;
    ::v-deep strong {
      color: #8e8e8e;
      line-height: 38px;
      padding-top: 23px;
    }
  }
}
.page2 {
  padding-top: 70px;
  .flexWrap {
    margin-top: 95px;
    padding-left: 136px;
    padding-right: 155px;
    .box {
      padding-bottom: 93px;
      &:nth-child(1) {
        margin-right: 290px;
      }
      &:nth-child(2) {
        padding-right: 40px;
      }
      &:nth-child(3) {
        padding-left: 12px;
      }
      .img {
        width: 256px;
        margin: 0 auto;
      }
      h3 {
        line-height: 28px;
        font-size: 28px;
        padding-top: 52px;
        padding-bottom: 14px;
      }
      p {
        font-size: 20px;
        line-height: 32px;
      }
    }
  }
}
.page3 {
  margin-top: 100px;
  padding-bottom: 139px;
  height: 1083px;
}
.page4 {
  height: 997px;
  padding-top: 136px;
  .flexWrap {
    padding-top: 65px;
  }
  .box {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 14px;
    padding: 0 17px;
    padding-top: 40px;
    margin-bottom: 20px;
    ._icon {
      width: 72px;
      height: 72px;
      display: inline-block;
    }
    &:hover {
      background: linear-gradient( 360deg, #FF9222 0%, #F56728 100%);
      h3 {
        color: #fff;
      }
      p {
        color: #fff;
      }
    }
  }
}
</style>
